import { ClickUI } from '@make-software/csprclick-ui';
import type React from 'react';

import { accountMenuItems } from './settings';
import { ClickTopBarContainer } from './styles';
import { type ClickTopBarProps } from './types';

export const ClickTopBar: React.FC<ClickTopBarProps> = ({ themeMode, onThemeSwitch }) => {
  return (
    <ClickTopBarContainer>
      <ClickUI
        topBarSettings={{
          onThemeSwitch: onThemeSwitch,
          accountMenuItems: accountMenuItems,
        }}
        themeMode={themeMode}
      />
    </ClickTopBarContainer>
  );
};
